import pollsCss from "../../assets/styles/polls/polls.module.scss";
import moment from "moment-timezone";
import { Header } from "semantic-ui-react";
import { LighteningIcon } from "../../assets/styles/polls/icons";

export default function ReportInformation({ poll }) {
  return (
    <div className={pollsCss.modalHeaderTitle}>
      <Header as="h2" style={{ margin: "14px 0" }}>
        {poll?.template_data?.question}
      </Header>
      <p className={pollsCss.pollsDates}>
        <span>
          {moment(poll?.created_at).format("DD MMM, YYYY") +
            (poll?.template_data?.hasEndDate
              ? " - " + moment(poll?.ends_at).format("DD MMM, YYYY")
              : "")}
        </span>
        <span>{poll?.total_responses} respondents</span>
      </p>
      {/* <div className={pollsCss.reportInformation}>
        <Header as="h3">
          <LighteningIcon /> Summary of key findings
        </Header>
        <ul>
          <li>Option X received the most votes</li>
          <li>Peak response time was within the first 24 hours</li>
          <li>12% overall response rate, exceeding the previous poll’s 10%.</li>
        </ul>
      </div> */}
      <div className={pollsCss.subReportInformation}>
        <p>
          All data is shown as totals. Individual email addresses are not stored
          or visible, maintaining compliance with privacy regulations.{" "}
         
        </p>
      </div>

      <div className={pollsCss.pollsReportSection}>
        <Header as="h1">Detailed Poll Results</Header>
        <Header as="h2">Distribution of Answers</Header>
      </div>
    </div>
  );
}
